import { Serializable } from '@/models/core/serializable';
import { SchoolClass } from '@/models/school-class/school-class';

export class SchoolClassPromotion implements Serializable<SchoolClassPromotion> {
  oldSchoolClass: SchoolClass;
  newSchoolClass: SchoolClass;
  note: string;
  canPromotion: boolean;

  // UI パラメータ
  selected: boolean = true;

  deserialize(input: any): SchoolClassPromotion {
    this.oldSchoolClass = new SchoolClass().deserialize(input.oldSchoolClass);
    this.newSchoolClass = new SchoolClass().deserialize(input.newSchoolClass);
    this.note = input.note;
    this.canPromotion = input.canPromotion;
    if (input.selected !== undefined) {
      this.selected = input.selected;
    }

    return this;
  }
}
